import React from 'react';

const SpeciesList = ({ speciesData }) => {
    // Function to extract and deduplicate relevant information from the data array
    const extractAndDeduplicateSpeciesInfo = (data) => {
        return data.map(species => ({
                commonName: species[0],
                imageUrl: species[6].url
            }))
            .reduce((acc, current) => {
                const duplicate = acc.find(item => item.commonName === current.commonName && item.imageUrl === current.imageUrl);
                if (!duplicate) {
                    acc.push(current);
                }
                return acc;
            }, []);
    };

    const speciesInfo = extractAndDeduplicateSpeciesInfo(speciesData.data);
    console.log('Deduplicated Species info:', speciesInfo);

    return (
        <div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {speciesInfo.map((species, index) => (
                    <div key={index} className="max-w-sm rounded overflow-hidden shadow-lg">
                        <img className="w-full" src={species.imageUrl} alt={species.commonName} />
                        <div className="px-6 py-4">
                            <div className="font-bold text-xl mb-2">{species.commonName}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SpeciesList;
